import { Observable } from 'rxjs';
import { AngularFireAuth} from '@angular/fire/auth';
import { Injectable } from '@angular/core';
import * as firebase from 'firebase';
import { ActivatedRoute } from '@angular/router';
import { AppUser } from '../Models/app-user';
import 'rxjs/add/operator/switchMap';
import 'rxjs/add/observable/of';
import { UserService } from './user.service';


@Injectable({
  providedIn: 'root'
})
export class AuthService {
 user$: Observable <firebase.User>
  constructor(private afauth: AngularFireAuth,private route : ActivatedRoute, private userService: UserService) {
     this.user$ = afauth.authState;
   }

   loginwithgoogle(){
    let returnUrl=  this.route.snapshot.queryParamMap.get('returnUrl') || '/';
    localStorage.setItem('returnUrl', returnUrl);
    this.afauth.auth.signInWithRedirect(new firebase.auth.GoogleAuthProvider());
   };

   loginwithfacebook(){
    let returnUrl=  this.route.snapshot.queryParamMap.get('returnUrl') || '/';
    localStorage.setItem('returnUrl', returnUrl);
    this.afauth.auth.signInWithRedirect(new firebase.auth.FacebookAuthProvider());
   }
   
   logoutwithgoogle(){
     this.afauth.auth.signOut();
   };

   get appUser$ ():Observable<AppUser>{
    return this.user$
    .switchMap(user => {
       if (user) return this.userService.get(user.uid).valueChanges()
       return Observable.of(null);
      });
    }
  
}
